export default {
  zh: {
    timeR: '倒计时 ',
    ruleText: '规则',
    DailyBenefits: '每日福利',
    applyRule: `- Registration for girls only <br>
    - you can register After reaching wealth level 10 <br>
    - Microphone hours are calculated if the microphone is open <br>
    - You can benefit from only one level after meeting all the requirements<br>
    - After registering and successfully completing the tasks, you can get the reward on Monday<br>
    - It for is strictly prohibited to register with more than one account, and if this is discovered, all accounts will be canceled and rejected Request to register again`,
    rule: '1- 仅限女孩</br>2- 无需注册即可参加月度王者排名，收到礼物后自动加入比赛</br>3- 比赛是收到礼物最多的女孩，这是表达人们对她获得“健谈女王”称号并获得该称号一个月的爱的一种方式</br>4- 比赛分3个位置，每个位置都有丰厚的奖励</br>5- 比赛每月更新一次</br>6- 如果一个竞争对手赢得了 3 次第一名，用户将获得一个 App Queen 头衔</br>7-所有礼物都无一例外地计算在内',
    content:
      '宰牲节的时间到了。</br>为了庆祝宰牲节</br>前 3 名用户将获得稀有而独特的奖牌。</br>房间也会收到礼物。</br>只有以下礼物将被计算在内：',
    mission: '任务',
    ranking: '排行',
    individual: '个人',
    room: '房间',
    rewards: '奖励',
    amount: '完成额度',
    collect: '收集',
    copyright: '本活动版权归App所有',
    collected: '收到',
    specialgift: 'special background gift',
    record: '记录',
    live1: 'App Queen 现已上线：',
    live2: '成为我们的女王之一并获得更多奖励！',
    monthlyLeaderboard: '每月排行榜',
    thismonth: '本月',
    lastmonth: '上个月',
    girlsupport: '成为女孩支持',
    onlyGirl: '只有女孩才能参加',
    chatrule: 'App拥有本次活动的最终权利。',
    service: '如果您有任何疑问，请点击此处联系客户服务.',

    refuseReason: '拒绝原因',
    currentMicTime: '当前上麦时间',
    meetConditions: (txt) => {
      return `满足条件后，6k金币将在${txt}后发放`
    },
    waitExamine: '正在等待审核',
    hadPass: '通过',
    apply: `Apply`,
    trOne: 'Level',
    trTwo: 'Number of microphone  hours',
    trThree: 'Number of users who send gifts',
    trFour: 'Value of gifts received',
    trFive: 'Reward'
  },
  en: {
    timeR: 'Count down: ',
    ruleText: 'Rule',
    DailyBenefits: 'Daily Benefits',
    applyRule: `- Registration for girls only <br>
    - you can register After reaching wealth level 10 <br>
    - Microphone hours are calculated if the microphone is open <br>
    - You can benefit from only one level after meeting all the requirements<br>
    - After registering and successfully completing the tasks, you can get the reward on Monday<br>
    - It for is strictly prohibited to register with more than one account, and if this is discovered, all accounts will be canceled and rejected Request to register again`,
    rule: `1.You can register After reaching wealth level 10.<br/>
    2.In the Queens system for all applications, the system is programmed not to count hours in these cases (Turn off mic or sound + room is locked) .<br/>
    3.You can benefit from only one level after meeting all the requirements.<br/>
    4.After registering and successfully completing the tasks, you can get the reward on Monday.<br/>
    5.It for is strictly prohibited to register with more than one account, and if this is discovered, all accounts will be canceled and rejected Request to register again.`,
    content:
      'It is time for Eid al-Adha.  </br>To celebrate Eid al-Adha date, </br>Rare and unique medals will be given to top 3 users.</br>Rooms will also receive gifts.</br>Only the following gifts will be counted:',
    mission: 'mission',
    ranking: 'ranking',
    individual: 'individual',
    room: 'room',
    rewards: 'rewards',
    amount: 'Amount accomplished',
    collect: 'collect',
    copyright: 'The copyright of this activity belongs to App',
    collected: 'received',
    specialgift: 'special background gift',
    record: 'Record',
    live1: 'App Queen is now live:',
    live2: 'Become one of our Queen and receive more rewards!',
    monthlyLeaderboard: 'Monthly leaderboard',
    thismonth: 'This month',
    lastmonth: 'Last month',
    girlsupport: 'Become a girl support',
    onlyGirl: 'For girls only',
    chatrule: 'App has the final right of this activity.',
    service: 'If you have questions, please click here to contact customer service.',

    refuseReason: 'Reject Reason',
    currentMicTime: 'Current microphone time',
    meetConditions: (txt) => {
      return `After meeting the conditions, 6k gold coins will be distributed after ${txt}`
    },
    waitExamine: 'Waiting for review',
    hadPass: 'Pass',
    apply: `Apply`,
    trOne: 'Level',
    trTwo: 'Number of microphone  hours',
    trThree: 'Number of users who send gifts',
    trFour: 'Value of gifts received',
    trFive: 'Reward'
  },
  ar: {
    timeR: 'العد التنازلي ',
    ruleText: 'قواعد',
    DailyBenefits: 'المكافأة اليومية',
    applyRule: `- التسجيل للبنات فقط <br/>
    - يمكنك التسجيل بعد الوصول إلى مستوى الثروة 10 <br/>
    - يتم احتساب ساعات الميكروفون إذا كان الميكروفون مفتوحا <br/>
    - يمكنك الاستفادة من مستوى واحد فقط بعد استيفاء كافة المتطلبات <br/>
    - بعد التسجيل وإتمام المهام بنجاح يمكنك الحصول على المكافأة يوم الاثنين <br/>
    - يمنع منعا باتا التسجيل بأكثر من حساب وفي حال اكتشاف ذلك سيتم إلغاء جميع الحسابات ورفض طلب التسجيل مرة أخرى`,
    rule: `1. يمكنك التسجيل بعد الوصول إلى مستوى الثروة 10.<br/>
    2. في نظام ملكة تشاتي لجميع المشتركين يتم برمجة النظام على عدم احتساب الساعات في هذه الحالات (إيقاف المايك أو الصوت + الغرفة مقفلة).<br/>
    3. يمكنك الاستفادة من مستوى واحد فقط بعد استيفاء كافة المتطلبات.<br/>
    4. بعد التسجيل وإكمال المهام بنجاح، يمكنك الحصول على المكافأة يوم الاثنين.<br/>
    5. يمنع منعاً باتاً التسجيل بأكثر من حساب، وفي حال اكتشاف ذلك سيتم إلغاء كافة الحسابات ورفض طلب التسجيل مرة أخرى.`,
    content:
      'حان وقت عيد الأضحى.</br>للاحتفال بعيد الأضحى المبارك ،</br>سيتم منح ميداليات نادرة وفريدة من نوعها لأفضل 3 مستخدمين.</br>ستحصل الغرف أيضًا على هدايا.</br>سيتم احتساب الهدايا التالية فقط:',
    mission: 'بعثة',
    ranking: 'تصنيف',
    individual: 'فرد',
    room: 'مجال',
    rewards: 'المكافآت',
    amount: 'المبلغ المنجز',
    collect: 'يجمع',
    copyright: 'حقوق الطبع والنشر لهذا النشاط تعود إلى App',
    collected: 'استلم',
    specialgift: 'هدية خلفية خاصة',
    record: 'سجل',

    live1: 'App Queen هو الآن مباشر:',
    live2: 'كن واحدة من ملكاتنا واحصل على المزيد من المكافآت!',
    monthlyLeaderboard: 'لوحة الصدارة الشهرية',
    thismonth: 'هذا الشهر',
    lastmonth: 'الشهر الماضي',
    girlsupport: 'كوني فتاة داعمة',
    onlyGirl: ' للفتيات فقط',
    chatrule: 'App لديه الحق النهائي في هذا النشاط.',
    service: 'إذا كانت لديك اي مشكله  ، يرجى النقر هنا للتواصل مع خدمة العملاء أحلام ',

    refuseReason: 'سبب الرفض',
    currentMicTime: 'ساعة علي المايك حاليا',
    meetConditions: (txt) => {
      return `سوف ينزل ست الاف كوينز بعد ${txt} بعد اكمال المهمات المطلوبة`
    },
    waitExamine: 'تحت المراجعة',
    hadPass: 'نجح',
    apply: `تطبق`,
    trOne: 'المستوى',
    trTwo: 'عدد ساعات المايك',
    trThree: 'عدد الداعمين',
    trFour: 'اجمالي قيمة الهدايا',
    trFive: 'الجائزة'
  },
  tr: {
    timeR: 'Etkinlik Geri Sayım',
    ruleText: 'Kural',
    DailyBenefits: 'Daily Benefits',
    applyRule: `- Kayıt Sadece Kadınlar  için <br/>
- Zenginlik seviyesi 10 a  ulaştıktan sonra kayıt olabilirsiniz.<br/>
- Mikrofon saatleri mikrofon açıksa hesaplanır<br/>
- Tüm gereksinimleri karşıladıktan sonra sadece bir seviyeden yararlanabilirsiniz<br/>
- Kayıt olduktan ve görevleri başarıyla tamamladıktan sonra, Pazartesi günü ödülü alabilirsiniz<br/>
- Birden fazla hesapla kayıt yaptırmak kesinlikle yasaktır, Eğer bu tespit edilirse, Tüm hesaplar iptal edilecek ve Tekrar kayıt isteği reddedilecektir.`,
    rule: `1. Zenginlik seviyesi 10'a ulaştıktan sonra kaydolabilirsiniz.<br/>
    2. Tüm hesaplar için App Kraliçesi  sisteminde, Sistem şu durumlarda saat saymayacak şekilde programlanmıştır. (Mikrofonu veya sesleri kapalı  + Oda kilitlidir)<br/>
    3. Tüm gereksinimleri karşıladıktan sonra sadece bir seviyeden yararlanabilirsiniz.<br/>
    4. Kayıt olduktan ve görevleri başarıyla tamamladıktan sonra, ödülü Pazartesi günü alabilirsiniz.<br/>
    5. Birden fazla hesapla kayıt yaptırmak kesinlikle yasaktır. Eğer bu tespit edilirse, Tüm hesaplar iptal edilecek ve yeniden kayıt talebi reddedilecektir.`,
    content:
      'Kurban Bayramı vakti geldi.</br>Kurban Bayramı tarihini kutlamak için,</br>İlk 3 kullanıcıya nadir ve benzersiz madalyalar verilecek.</br>Odalara ayrıca hediyeler verilecektir.</br>Yalnızca aşağıdaki hediyeler sayılacaktır:',
    mission: 'misyon',
    ranking: 'sıralama',
    individual: 'bireysel',
    room: 'oda',
    rewards: 'Ödüller',
    amount: 'Tamamlanan miktar',
    collect: 'toplamak',
    copyright: "Bu etkinliğin telif hakkı App'ye aittir.",
    collected: 'alındı',
    specialgift: 'özel arka plan hediyesi',
    record: 'Kayıt',
    live1: 'App Queen şimdi yayında:',
    live2: 'Kraliçemizden biri olun ve daha fazla ödül kazanın!',
    monthlyLeaderboard: 'Aylık lider tablosu',
    thismonth: 'Bu ay',
    lastmonth: 'Geçen ay',
    girlsupport: 'kız desteği ol',
    onlyGirl: 'Sadece kızlar için',
    chatrule: 'App bu aktivitenin son hakkına sahiptir.',
    service: 'Sorularınız varsa lütfen servisle iletişime geçmek için buraya tıklayın',

    refuseReason: 'Reddetme Nedeni',
    currentMicTime: 'Geçerli mikrofon süresi',
    meetConditions: (txt) => {
      return `Koşulları karşıladıktan sonra, ${txt} sonrasında 6k altın para basılacaktır.`
    },
    waitExamine: 'inceleme bekleniyor',
    hadPass: 'Onaylı',
    apply: `Kurallar`,
    trOne: 'Seviye',
    trTwo: 'Mikrofon Saat Süresi',
    trThree: 'Hediye Gönderen Kullanıcı Sayısı',
    trFour: 'Alınan Hediyelerin Değeri',
    trFive: 'Ödül'
  },
  jp: {
    timeR: 'カウントダウン: ',
    ruleText: 'Rule',
    DailyBenefits: 'Daily Benefits',
    applyRule: `- Registration for girls only <br>
    - you can register After reaching wealth level 10 <br>
    - Microphone hours are calculated if the microphone is open <br>
    - You can benefit from only one level after meeting all the requirements<br>
    - After registering and successfully completing the tasks, you can get the reward on Monday<br>
    - It for is strictly prohibited to register with more than one account, and if this is discovered, all accounts will be canceled and rejected Request to register again`,
    rule: '1-女の子のみ</br>2-登録なしで毎月のロイヤルランキングに参加できます。ギフトを受け取った場合にのみ、自動的にコンテストに参加できます。</br>3-コンテストは、最も多くの贈り物を受け取る女の子です。これは、彼女がおしゃべりな女王の称号を取得し、この称号を1か月間取得することへの人々の愛を表現する方法です。</br>4-競争は3つのポジションで行われ、各ポジションには貴重な報酬があります</br>5-コンテストは毎月更新されます</br>6-競合他社が3回優勝した場合、ユーザーはAppQueenの称号を受け取ります。</br>7-すべての贈り物は例外なくカウントされます',
    content:
      'イード・アル＝アドハーの時間です。</br>イードアルアドハーの日付を祝うために、</br>珍しいユニークなメダルが上位3人のユーザーに贈られます。</br>客室にもギフトが贈られます。</br>次のギフトのみがカウントされます。',
    mission: 'ミッション',
    ranking: 'ランキング',
    individual: '個人',
    room: '部屋',
    rewards: '報酬',
    amount: '達成量',
    collect: '収集',
    copyright: 'この活動の著作権はAppに帰属します',
    collected: '受信',
    specialgift: '特別な背景ギフト',
    record: '記録',
    live1: 'App Queen is now live:',
    live2: 'Become one of our Queen and receive more rewards!',
    monthlyLeaderboard: '月間リーダーボード',
    thismonth: '今月',
    lastmonth: '先月',
    girlsupport: '女の子のサポートになる',
    onlyGirl: '女の子のみ',
    chatrule: 'App は、このアクティビティの最終的な権利を有します。',
    service: 'ご不明な点がございましたら、ここをクリックしてカスタマー サービス  にお問い合わせください。',

    refuseReason: '拒否理由',
    currentMicTime: '現在のマイクタイム',
    meetConditions: (txt) => {
      return `条件を満たすと、${txt}以降に6,000枚の金貨が発行されます`
    },
    waitExamine: '審査待ち',
    hadPass: '合格',
    apply: `申し込む`,
    trOne: 'Level',
    trTwo: 'Number of microphone  hours',
    trThree: 'Number of users who send gifts',
    trFour: 'Value of gifts received',
    trFive: 'Reward'
  },
  uz: {
    timeR: 'Sanash: ',
    ruleText: 'Qoidalar',
    DailyBenefits: 'Kunlik foydalar',
    applyRule: `- Faqat qizlar uchun ro'yxatdan o'tish<br>
    - Boylik darajasi 10 ga etgandan keyin ro'yxatdan o'tishingiz mumkin<br>
    - Mikrofon ishlatilgan vaqtlar mikrofon ochilgan holda hisoblanadi<br>
    - Barcha talablar bajarilgandan so'ng faqat bitta darajadan foydalana olasiz<br>
    - Ro'yxatdan o'tgandan va vazifalarni muvaffaqiyatli bajargandan so'ng, siz mukofotni dushanba kuni olishingiz mumkin<br>
    - Bir nechta akkaunt bilan ro'yxatdan o'tish qat'iyan man etiladi, agar bu aniqlansa, barcha akkauntlar bekor qilinadi va yana ro'yxatdan o'tish so'rovi rad etiladi`,
    rule: `1. Boylik darajasi 10 ga etgandan keyin ro'yxatdan o'tishingiz mumkin.<br/>
    2. Queens tizimida barcha arizalar uchun, tizim quyidagi holatlarda vaqtni hisoblamaydi (mikrofonni o'chirish yoki ovozni o'chirish + xona qulflangan).<br/>
    3. Barcha talablar bajarilgandan so'ng faqat bitta darajadan foydalana olasiz.<br/>
    4. Ro'yxatdan o'tgandan va vazifalarni muvaffaqiyatli bajargandan so'ng, siz mukofotni dushanba kuni olishingiz mumkin.<br/>
    5. Bir nechta akkaunt bilan ro'yxatdan o'tish qat'iyan man etiladi, agar bu aniqlansa, barcha akkauntlar bekor qilinadi va yana ro'yxatdan o'tish so'rovi rad etiladi.`,
    content:
      "Eyd al-Adha vaqtining kelishi shodligi. </br> Eyd al-Adha bayramiga bag'ishlangan sanada, </br> Top 3 foydalanuvchiga noyob va kamyob medallar taqdim etiladi.</br>Xonalarga ham sovg‘alar yuboriladi.</br> Faqat quyidagi sovg‘alar hisobga olinadi:",
    mission: 'Vazifa',
    ranking: 'Reyting',
    individual: 'Shaxsiy',
    room: 'Xona',
    rewards: 'Mukofotlar',
    amount: 'Bajarilgan miqdor',
    collect: "Yig'ish",
    copyright: 'Ushbu faoliyatning mualliflik huquqi Appga tegishli',
    collected: 'Olingan',
    specialgift: 'Maxsus fon sovg‘asi',
    record: 'Rekord',
    live1: 'App Queen hozirda jonli:',
    live2: "Bizning Queen bo'ling va ko'proq mukofotlar oling!",
    monthlyLeaderboard: 'Oylik reyting',
    thismonth: 'Ushbu oy',
    lastmonth: "O'tgan oy",
    girlsupport: "Qizlarni qo'llab-quvvatlashga a'zo bo'ling",
    onlyGirl: 'Faqat qizlar uchun',
    chatrule: 'Bu faoliyatning yakuniy huquqi Appga tegishli.',
    service: "Agar savollaringiz bo'lsa, iltimos, mijozlarga xizmat ko'rsatish bilan bog'lanish uchun bu yerga bosing.",
    refuseReason: 'Rad etish sababi',
    currentMicTime: 'Hozirgi mikrofon vaqti',
    meetConditions: (txt) => {
      return `${txt}dan keyin 6k oltin tanga tarqatiladi`
    },
    waitExamine: 'Tekshiruvni kutish',
    hadPass: "O'tdi",
    apply: 'Ariza',
    trOne: 'Daraja',
    trTwo: 'Mikrofon vaqtlarining soni',
    trThree: 'Sovg‘a yuborgan foydalanuvchilar soni',
    trFour: 'Olingan sovg‘alar qiymati',
    trFive: 'Mukofot'
  },
  ru: {
    timeR: 'Обратный отсчет: ',
    ruleText: 'Правила',
    DailyBenefits: 'Ежедневные бонусы',
    applyRule: `- Регистрация только для девушек<br>
    - Вы можете зарегистрироваться после достижения уровня богатства 10<br>
    - Время микрофона учитывается только если микрофон включен<br>
    - Вы можете получить только один уровень после выполнения всех требований<br>
    - После регистрации и успешного выполнения задач, вы получите награду в понедельник<br>
    - Строго запрещено регистрироваться с несколькими аккаунтами, если это будет обнаружено, все аккаунты будут отменены, а запрос на повторную регистрацию отклонен`,
    rule: `1. Вы можете зарегистрироваться после достижения уровня богатства 10.<br/>
    2. В системе Queens для всех заявок система не учитывает часы, если (выключен микрофон или звук + комната заблокирована).<br/>
    3. Вы можете получить только один уровень после выполнения всех требований.<br/>
    4. После регистрации и успешного выполнения задач, вы получите награду в понедельник.<br/>
    5. Строго запрещено регистрироваться с несколькими аккаунтами, если это будет обнаружено, все аккаунты будут отменены, а запрос на повторную регистрацию отклонен.`,
    content:
      'Время для праздника Курбан-байрам. </br> В честь праздника Курбан-байрам, </br> Топ-3 пользователей получат редкие и уникальные медали.</br> Комнаты также получат подарки.</br> Будут засчитаны только следующие подарки:',
    mission: 'Задание',
    ranking: 'Рейтинг',
    individual: 'Индивидуально',
    room: 'Комната',
    rewards: 'Награды',
    amount: 'Достигнутое количество',
    collect: 'Собрать',
    copyright: 'Авторские права на это мероприятие принадлежат App',
    collected: 'Получено',
    specialgift: 'Специальный подарок фона',
    record: 'Запись',
    live1: 'App Queen сейчас в прямом эфире:',
    live2: 'Стань нашей королевой и получай больше наград!',
    monthlyLeaderboard: 'Ежемесячный рейтинг',
    thismonth: 'Этот месяц',
    lastmonth: 'Прошлый месяц',
    girlsupport: 'Стань поддержкой для девушек',
    onlyGirl: 'Только для девушек',
    chatrule: 'App имеет окончательное право на интерпретацию этого мероприятия.',
    service: 'Если у вас есть вопросы, нажмите сюда, чтобы связаться с обслуживанием клиентов.',
    refuseReason: 'Причина отказа',
    currentMicTime: 'Текущее время микрофона',
    meetConditions: (txt) => {
      return `После выполнения условий будет распределено 6k золотых монет после ${txt}`
    },
    waitExamine: 'Ожидание проверки',
    hadPass: 'Пройдено',
    apply: 'Подать заявку',
    trOne: 'Уровень',
    trTwo: 'Число часов микрофона',
    trThree: 'Число пользователей, отправивших подарки',
    trFour: 'Стоимость полученных подарков',
    trFive: 'Награда'
  },
  fa: {
    timeR: 'شمارش معکوس: ',
    ruleText: 'قوانین',
    DailyBenefits: 'مزایای روزانه',
    applyRule: `- ثبت‌نام فقط برای دختران<br>
    - می‌توانید پس از رسیدن به سطح ثروت 10 ثبت‌نام کنید<br>
    - ساعت‌های میکروفون فقط زمانی محاسبه می‌شود که میکروفون روشن باشد<br>
    - فقط پس از انجام تمام شرایط می‌توانید از یک سطح بهره‌مند شوید<br>
    - پس از ثبت‌نام و انجام موفقیت‌آمیز وظایف، می‌توانید پاداش خود را در روز دوشنبه دریافت کنید<br>
    - ثبت‌نام با چندین حساب کاملاً ممنوع است و در صورت کشف این موضوع، تمام حساب‌ها لغو و درخواست ثبت‌نام مجدد رد خواهد شد`,
    rule: `1. پس از رسیدن به سطح ثروت 10 می‌توانید ثبت‌نام کنید.<br/>
    2. در سیستم Queens برای تمام درخواست‌ها، سیستم ساعت‌ها را در این موارد محاسبه نمی‌کند (میکروفون خاموش است یا صدا قطع شده است + اتاق قفل شده است).<br/>
    3. فقط پس از انجام تمام شرایط می‌توانید از یک سطح بهره‌مند شوید.<br/>
    4. پس از ثبت‌نام و انجام موفقیت‌آمیز وظایف، می‌توانید پاداش خود را در روز دوشنبه دریافت کنید.<br/>
    5. ثبت‌نام با چندین حساب کاملاً ممنوع است و در صورت کشف این موضوع، تمام حساب‌ها لغو و درخواست ثبت‌نام مجدد رد خواهد شد.`,
    content:
      'زمان برای عید قربان فرا رسیده است. </br> برای جشن تاریخ عید قربان، </br> مدال‌های نادر و منحصر به فرد به 3 کاربر برتر اهدا خواهد شد.</br> اتاق‌ها نیز هدایا دریافت خواهند کرد.</br> تنها هدایا زیر محاسبه خواهند شد:',
    mission: 'مأموریت',
    ranking: 'رتبه‌بندی',
    individual: 'شخصی',
    room: 'اتاق',
    rewards: 'جوایز',
    amount: 'مقدار انجام‌شده',
    collect: 'جمع‌آوری',
    copyright: 'حق تکثیر این فعالیت متعلق به App است',
    collected: 'دریافت شده',
    specialgift: 'هدیه پس‌زمینه ویژه',
    record: 'رکورد',
    live1: 'App Queen اکنون زنده است:',
    live2: 'یکی از ملکه‌های ما شوید و جوایز بیشتری دریافت کنید!',
    monthlyLeaderboard: 'رتبه‌بندی ماهانه',
    thismonth: 'این ماه',
    lastmonth: 'ماه گذشته',
    girlsupport: 'پشتیبانی دختران شوید',
    onlyGirl: 'فقط برای دختران',
    chatrule: 'App حق نهایی در مورد این فعالیت را دارد.',
    service: 'اگر سوالی دارید، لطفاً اینجا کلیک کنید تا با پشتیبانی مشتریان تماس بگیرید.',
    refuseReason: 'دلیل رد درخواست',
    currentMicTime: 'زمان میکروفون فعلی',
    meetConditions: (txt) => {
      return `پس از انجام شرایط، 6k سکه طلای توزیع خواهد شد پس از ${txt}`
    },
    waitExamine: 'در انتظار بررسی',
    hadPass: 'قبول شده',
    apply: 'درخواست',
    trOne: 'سطح',
    trTwo: 'تعداد ساعت‌های میکروفون',
    trThree: 'تعداد کاربران ارسال‌کننده هدایا',
    trFour: 'ارزش هدایا دریافت‌شده',
    trFive: 'پاداش'
  },
  pt: {
    timeR: 'Contagem regressiva: ',
    ruleText: 'Regra',
    DailyBenefits: 'Benefícios Diários',
    applyRule: `- Registro apenas para meninas<br>
    - Você pode se registrar depois de alcançar o nível de riqueza 10<br>
    - As horas de microfone são calculadas se o microfone estiver aberto<br>
    - Você pode se beneficiar de apenas um nível após atender todos os requisitos<br>
    - Após se registrar e completar com sucesso as tarefas, você pode receber a recompensa na segunda-feira<br>
    - É estritamente proibido registrar mais de uma conta, e se isso for descoberto, todas as contas serão canceladas e a solicitação para se registrar novamente será rejeitada`,
    rule: `1. Você pode se registrar após alcançar o nível de riqueza 10.<br/>
    2. No sistema Queens, para todas as inscrições, o sistema foi programado para não contar horas nesses casos (microfone desligado ou som + sala bloqueada).<br/>
    3. Você pode se beneficiar de apenas um nível após atender todos os requisitos.<br/>
    4. Após se registrar e completar as tarefas com sucesso, você pode receber a recompensa na segunda-feira.<br/>
    5. É estritamente proibido registrar mais de uma conta, e se isso for descoberto, todas as contas serão canceladas e a solicitação para se registrar novamente será rejeitada.`,
    content:
      'Chegou a hora para o Eid al-Adha. </br> Para celebrar a data do Eid al-Adha, </br> Medais raras e únicas serão dadas aos 3 melhores usuários.</br> As salas também receberão presentes.</br> Somente os seguintes presentes serão contados:',
    mission: 'Missão',
    ranking: 'Ranking',
    individual: 'Individual',
    room: 'Sala',
    rewards: 'Recompensas',
    amount: 'Quantidade realizada',
    collect: 'Coletar',
    copyright: 'Os direitos autorais desta atividade pertencem ao App',
    collected: 'Recebido',
    specialgift: 'Presente de fundo especial',
    record: 'Registro',
    live1: 'App Queen está ao vivo agora:',
    live2: 'Torne-se uma de nossas Rainhas e receba mais recompensas!',
    monthlyLeaderboard: 'Ranking mensal',
    thismonth: 'Este mês',
    lastmonth: 'Mês passado',
    girlsupport: 'Torne-se um apoio para meninas',
    onlyGirl: 'Somente para meninas',
    chatrule: 'O App tem o direito final desta atividade.',
    service: 'Se você tiver dúvidas, clique aqui para entrar em contato com o atendimento ao cliente.',
    refuseReason: 'Motivo da recusa',
    currentMicTime: 'Tempo atual do microfone',
    meetConditions: (txt) => {
      return `Após atender aos requisitos, 6k moedas de ouro serão distribuídas após ${txt}`
    },
    waitExamine: 'Aguardando revisão',
    hadPass: 'Aprovado',
    apply: 'Aplicar',
    trOne: 'Nível',
    trTwo: 'Número de horas de microfone',
    trThree: 'Número de usuários que enviaram presentes',
    trFour: 'Valor dos presentes recebidos',
    trFive: 'Recompensa'
  },
  id: {
    timeR: 'Hitung mundur: ',
    ruleText: 'Aturan',
    DailyBenefits: 'Manfaat Harian',
    applyRule: `- Pendaftaran hanya untuk gadis<br>
    - Anda dapat mendaftar setelah mencapai level kekayaan 10<br>
    - Jam mikrofon dihitung jika mikrofon terbuka<br>
    - Anda hanya dapat memanfaatkan satu level setelah memenuhi semua persyaratan<br>
    - Setelah mendaftar dan menyelesaikan tugas dengan sukses, Anda dapat menerima hadiah pada hari Senin<br>
    - Sangat dilarang untuk mendaftar dengan lebih dari satu akun, dan jika ini ditemukan, semua akun akan dibatalkan dan permintaan untuk mendaftar lagi akan ditolak`,
    rule: `1. Anda dapat mendaftar setelah mencapai level kekayaan 10.<br/>
    2. Dalam sistem Queens untuk semua aplikasi, sistem diprogram untuk tidak menghitung jam dalam kasus ini (matikan mikrofon atau suara + ruangan terkunci).<br/>
    3. Anda hanya dapat memanfaatkan satu level setelah memenuhi semua persyaratan.<br/>
    4. Setelah mendaftar dan menyelesaikan tugas dengan sukses, Anda dapat menerima hadiah pada hari Senin.<br/>
    5. Sangat dilarang untuk mendaftar dengan lebih dari satu akun, dan jika ini ditemukan, semua akun akan dibatalkan dan permintaan untuk mendaftar lagi akan ditolak.`,
    content:
      'Ini adalah waktu untuk Eid al-Adha. </br> Untuk merayakan tanggal Eid al-Adha, </br> Medali langka dan unik akan diberikan kepada 3 pengguna teratas.</br> Ruangan juga akan menerima hadiah.</br> Hanya hadiah berikut yang akan dihitung:',
    mission: 'Misi',
    ranking: 'Peringkat',
    individual: 'Individu',
    room: 'Ruang',
    rewards: 'Hadiah',
    amount: 'Jumlah yang tercapai',
    collect: 'Kumpulkan',
    copyright: 'Hak cipta kegiatan ini milik App',
    collected: 'Diterima',
    specialgift: 'Hadiah latar belakang khusus',
    record: 'Rekor',
    live1: 'App Queen sekarang sedang siaran langsung:',
    live2: 'Jadilah salah satu Ratu kami dan terima lebih banyak hadiah!',
    monthlyLeaderboard: 'Papan peringkat bulanan',
    thismonth: 'Bulan ini',
    lastmonth: 'Bulan lalu',
    girlsupport: 'Jadilah dukungan gadis',
    onlyGirl: 'Hanya untuk gadis',
    chatrule: 'App memiliki hak akhir dari kegiatan ini.',
    service: 'Jika Anda memiliki pertanyaan, klik di sini untuk menghubungi layanan pelanggan.',
    refuseReason: 'Alasan Penolakan',
    currentMicTime: 'Waktu mikrofon saat ini',
    meetConditions: (txt) => {
      return `Setelah memenuhi persyaratan, 6k koin emas akan dibagikan setelah ${txt}`
    },
    waitExamine: 'Menunggu tinjauan',
    hadPass: 'Lulus',
    apply: 'Lamar',
    trOne: 'Tingkat',
    trTwo: 'Jumlah jam mikrofon',
    trThree: 'Jumlah pengguna yang mengirim hadiah',
    trFour: 'Nilai hadiah yang diterima',
    trFive: 'Hadiah'
  }
}



// WEBPACK FOOTER //
// src/pages/activity/ladies/lang.js